module.exports = __webpack_public_path__ + "static/media/bm.a64a3666.svg";